import type { SVGProps } from "react";
export function Apple(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      fill="none"
      height={16}
      viewBox="0 0 16 16"
      width={16}
      xmlns="http://www.w3.org/2000/svg"
      data-slot="icon"
      {...props}
    >
      <path
        d="m7.74937 4.81465c-.584 0-1.488-.664-2.44-.64-1.256.016-2.408.728-3.056 1.856-1.303996 2.264-.336 5.60795.936 7.44805.624.896 1.36 1.9039 2.336 1.8719.936-.04 1.288-.608 2.424-.608 1.128 0 1.448.608 2.44003.584 1.008-.016 1.648-.912 2.264-1.816.712-1.04 1.008-2.0479 1.024-2.104-.024-.0079-1.96-.752-1.984-2.99195-.016-1.872 1.528-2.768 1.6-2.808-.88-1.288-2.232-1.432-2.704-1.464-1.23203-.096-2.26403.672-2.84003.672zm2.08-1.888c.52003-.624.86403-1.496.76803-2.36-.74403.032-1.64003.496-2.17603 1.12-.48.552-.896 1.44-.784 2.288.824.064 1.672-.424 2.192-1.048z"
        fill="currentColor"
      />
    </svg>
  );
}
